"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumScreenNames = void 0;
var EnumScreenNames;
(function (EnumScreenNames) {
    EnumScreenNames["CAR_FAX_SCREEN"] = "CAR_FAX_SCREEN";
    EnumScreenNames["POST_VIEW_SCREEN"] = "POST_VIEW_SCREEN";
    EnumScreenNames["MID_SCREEN"] = "MID_SCREEN";
    EnumScreenNames["SHOP_DETAILS_SCREEN"] = "SHOP_DETAILS_SCREEN";
    EnumScreenNames["SHOP_LISTING_SCREEN"] = "SHOP_LISTING_SCREEN";
    EnumScreenNames["WEATHER_SCREEN"] = "WEATHER_SCREEN";
    EnumScreenNames["HOME_PAGE"] = "HOME_PAGE";
    EnumScreenNames["LANDING_PAGE"] = "LANDING_PAGE";
    EnumScreenNames["SERP_SCREEN"] = "SERP_SCREEN";
    EnumScreenNames["FIND_SCREEN"] = "FIND_SCREEN";
    EnumScreenNames["PRAYER_TIME_SCREEN"] = "PRAYER_TIME_SCREEN";
    EnumScreenNames["OPENSOOQ_LOGO_SCREEN"] = "OPENSOOQ_LOGO_SCREEN";
    EnumScreenNames["CAR_PRICES_SCREEN"] = "CAR_PRICES_SCREEN";
    EnumScreenNames["AUTOS_SERVICE_SCREEN"] = "AUTOS_SERVICE_SCREEN";
    EnumScreenNames["TAGS_DETAILS"] = "TAGS_DETAILS";
    EnumScreenNames["ADVERTISING_PRODUCTS"] = "ADVERTISING_PRODUCTS";
    EnumScreenNames["SALES_REPRESENTATIVES"] = "SALES_REPRESENTATIVES";
    EnumScreenNames["SAFETY_TIPS_SCREEN"] = "SAFETY_TIPS_SCREEN";
    EnumScreenNames["SUPPORT_INDEX_SCREEN"] = "SUPPORT_INDEX_SCREEN";
    EnumScreenNames["SUPPORT_FAQ_SCREEN"] = "SUPPORT_FAQ_SCREEN";
    EnumScreenNames["CONTACT_US_SCREEN"] = "CONTACT_US_SCREEN";
    EnumScreenNames["ADD_FREE_POST"] = "ADD_FREE_POST";
})(EnumScreenNames = exports.EnumScreenNames || (exports.EnumScreenNames = {}));
